import { trace } from 'rytm-helpers'


export const initOffcanvas = () => {
  // add / remove classes
  document.addEventListener("show.bs.offcanvas", onOffcanvasShow);
  document.addEventListener("shown.bs.offcanvas", onOffcanvasShown);
  document.addEventListener("hide.bs.offcanvas", onOffcanvasHide);
  document.addEventListener("hidden.bs.offcanvas", onOffcanvasHidden);
  document.documentElement.addEventListener("show.bs.collapse", onOffcanvasShow);
  document.documentElement.addEventListener("hide.bs.collapse", onOffcanvasHidden);
}

const onOffcanvasShow = (e) => {
  const input = e.target.querySelector('input');
  if (input) {
    setTimeout(() => {
      input.focus();
    }, 400);
  }
  if (e.target.dataset.htmlClassName) {
    document.documentElement.classList.add(e.target.dataset.htmlClassName);
  }
}
const onOffcanvasShown = (e) => {
  if (e.target.dataset.htmlClassName) {
    document.documentElement.classList.add(e.target.dataset.htmlClassName);
  }
}
const onOffcanvasHide = (e) => {
  if (e.target.dataset.htmlClassName) {
    document.documentElement.classList.add(e.target.dataset.htmlClassName + "--hiding");
  }
}
const onOffcanvasHidden = (e) => {
  if (e.target.dataset.htmlClassName) {
    document.documentElement.classList.remove(e.target.dataset.htmlClassName);
    document.documentElement.classList.remove(e.target.dataset.htmlClassName + "--hiding");
  }
}